


















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import Table from '@/components/Table/Table.vue';
import GoToCard from '@/components/ActionCards/GoToCard.vue';
import FilterCard from '@/components/ActionCards/FilterCard.vue';
import SnippetCard from '@/components/ActionCards/SnippetCard.vue';
import MacroCard from '@/components/ActionCards/MacroCard.vue';

import getters from '@/store/getters.ts';

@Component({
	components: {
		Table,
		GoToCard,
		FilterCard,
		SnippetCard,
		MacroCard
	}
})
export default class DataPanel extends Vue {
	@Prop() private noResults!: boolean;
	@State private rows!: any;
	@State private columns!: any;
	@State private dataPanelSide!: string;
	@State private totalRows!: number;
	@State private list!: any;
	@State private activeIdx!: any;

	@State private launcherState!: number;
	@State private previewState!: any;

	@Getter private activeItem!: number;
	@Getter private displayList!: any;

	@Action private modifyExtractor!: any;
	@Action private setPreviewState!: any;

	private get item() {
		if (this.displayList.length) {
			const item = this.displayList[this.activeIdx];
			this.setPreviewState(item);
			return item;
		} else {
			return this.previewState;
		}
	}

	private get mode() {
		if (this.displayList.length) {
			return this.displayList[this.activeIdx].actionType;		
		} else {
			if (this.previewState && this.previewState.actionType) {
				return this.previewState.actionType;
			} else {
				return null;
			}
		}
	}

	private get displayEmptyString() {
		switch (this.mode) {
			case 'ImportFromList':
			case 'ViewList':
			case 'AddToList':
				return 'This list is empty!';
				break;
			case 'SingleExtract':
			case 'MultipleExtract':
			case 'AutomatedWalkthrough':
				return 'Try creating a new extractor!';
				break;
			case 'Snippet':
				return 'Try creating a new snippet!';
				break;
			default:
				return 'Nothing to show here!';
				break;
		}
	}
}

